import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ListSubheader from "@mui/material/ListSubheader";
import InputBase from "@mui/material/InputBase";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const SelectDropDown = ({
  heading,
  listItem = false,
  onClickHandler,
  selectedOption,
  dropdownFor,
  title,
  default_title,
  sx,
  name,
  disabled = false,
  className,
  url,
  valueName,
  menuClassName = "",
  searchable = false,
}) => {
  const [searchText, setSearchText] = React.useState("");
  const query = searchable ? searchText.trim().toLowerCase() : "";
  const matchesQuery = (item) =>
    !query ||
    String(item?.[title] ?? "")
      .toLowerCase()
      .includes(query);
  const hasMatches =
    Array.isArray(listItem) && listItem.some((item) => matchesQuery(item));
  return (
    <>
      <FormControl sx={{ ...sx }} disabled={disabled} fullWidth>
        <Select
          IconComponent={ExpandMoreIcon}
          sx={{
            fontFamily: "CircularSTDBook",
            "& .MuiSvgIcon-root": {
              color: "var(--qv-tx-000000, black)",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "var(--qv-input-focus-border, var(--qv-bd-000000, black))",
            },
          }}
          size="small"
          value={selectedOption}
          displayEmpty
          defaultValue={listItem[0]}
          renderValue={default_title && ((value) => default_title)}
          className={className}
          // sx={{fontFamily:"inherit"}}
          onClose={searchable ? () => setSearchText("") : undefined}
          MenuProps={{
            autoFocus: !searchable,
            PaperProps: {
              sx: {
                "&::-webkit-scrollbar": {
                  width: "2px",
                  height: "auto",
                },
              },
              className: `Dropdown-Selected-Android ${menuClassName}`.trim(),
            },
          }}
        >
          {searchable && (
            <ListSubheader
              sx={{
                px: 1,
                pt: 1,
                pb: 0.5,
                lineHeight: "normal",
                background: "var(--qv-bg-ffffff, #fff)",
              }}
            >
              <InputBase
                autoFocus
                fullWidth
                placeholder="Search..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") e.stopPropagation();
                }}
                sx={{
                  fontFamily: "CircularSTDBook",
                  px: 1,
                  py: 0.25,
                  border: "1px solid var(--qv-bd-e3e3e3, #E3E3E3)",
                  borderRadius: "4px",
                }}
              />
            </ListSubheader>
          )}
          {heading && (
            <MenuItem
              sx={{ fontFamily: "CircularSTDBook", display: query ? "none" : undefined }}
              onClick={(e) => {
                onClickHandler(heading, dropdownFor);
              }}
              value={heading}
            >
              {heading}
            </MenuItem>
          )}

          {listItem &&
            listItem.length > 0 &&
            listItem?.map((item, index) => (
              <MenuItem
                disabled={item?.disabled}
                sx={{
                  fontFamily: "CircularSTDBook",
                  display: matchesQuery(item) ? undefined : "none",
                }}
                key={index}
                onClick={(e) => {
                  onClickHandler(item, dropdownFor, name);
                }}
                value={valueName ? item[valueName] : item[title]}
                // className={item[url]+'-Android'}
                className={`${item.className ? item.className : ""}`}
              >
                {item[title]}
              </MenuItem>
            ))}
          {searchable && !hasMatches && (
            <MenuItem disabled sx={{ fontFamily: "CircularSTDBook" }}>
              No options found
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </>
  );
};

export default SelectDropDown;
